import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core";
import ToolBar from "./ToolBar";
import ScreenBar from "./ScreenBar";
import {ScreenDesignerContextNew} from "../../../../../ContextComponents/ScreenDesignerContextNew";
import useScreenDesigner from "./screenDesigner.hook";
import DragLayerComponent from "./ToolBar/DragComponents/DragLayer";
import Loading from "../../../../../Utils/Loading/Loading";


const useStyles = makeStyles({
    container: {
        display: 'flex',
        height: '100%',
        width: '100%'
    }
});

const ScreenDesigner = ({designerType, ...props}) => {
    const {
        screenValues,
        screenTypeProps,
        isDesignerReady,
        loading,
        loadInitialData,
        resolution,
        setScreenResolution,
        lists,
        listStorage,
        openListDesigner,
        toggleListDesigner,
        selectedComponent,
        onSelectStyleTemplate,
        selectedComponentRef,
        suggestions,
        uploadedImages,
        setImageContent,
        setListData,
        initData,
        scriptSuggestions,
        droppedEntities,
        preparedToSaveLists,
        saveScreen,
        removeScreen,
        closeScreen,
        toggleOpenTemplates,
        onSelectTemplate,
        openSelectTemplate,
        onDropComponent,
        dropInEveryChild,
        onDropMultipleComponents,
        onDeleteComponent,
        onSelectComponent,
        onMoveComponent,
        onDuplicateComponent,
        onChangeDefaultFields,
        prepareToSaveLists,
        //event and actions handlers
        onChangeEventComponent,
        actionSave,
        createEvent,
        removeEvent,
        setSelectedComponent,
        addNewList,
        currentCustomResolution
    } = useScreenDesigner(props.match.params.id);
    const classes = useStyles();
    useEffect(() => {
        if(!props.match.params.id) {
            toggleOpenTemplates();
        }
        initData(props.match.params.id);
    }, [props.match.params.id]);
    const resolutionObject = screenValues.resolution ? screenValues.resolution : {width: '100%', height: 'auto'};

    return (
        isDesignerReady ? (
            <ScreenDesignerContextNew.Provider value={{
                designerType,
                screenTypeProps,
                loading,
                screenValues,
                resolution,
                selectedComponent,
                selectedComponentRef,
                droppedEntities,
                suggestions,
                lists,
                listStorage,
                scriptSuggestions,
                openListDesigner,
                uploadedImages,
                preparedToSaveLists,
                onSelectStyleTemplate,
                setSelectedComponent,
                currentCustomResolution,
                toggleListDesigner,
                setScreenResolution,
                setImageContent,
                setListData,
                saveScreen,
                removeScreen,
                closeScreen,
                toggleOpenTemplates,
                onSelectTemplate,
                openSelectTemplate,
                onDropComponent,
                dropInEveryChild,
                onDropMultipleComponents,
                onDeleteComponent,
                onSelectComponent,
                onMoveComponent,
                onDuplicateComponent,
                onChangeDefaultFields,
                prepareToSaveLists,
                //event and actions handlers
                onChangeEventComponent,
                actionSave,
                createEvent,
                removeEvent,
                addNewList
            }}>
                <div className={classes.container} id="screenDesignerLayout">
                    <DragLayerComponent/>
                    <ToolBar/>
                    <div style={{
                        margin: resolutionObject.height !== 'auto' ? '2px auto' : '2px 2px',
                        border: resolutionObject.height === 'auto' ? '1px solid transparent' : '1px solid #8080804d',
                        borderRadius: 5,
                        overflow: 'auto',
                        ...resolutionObject
                    }}>
                        {loadInitialData ? (
                            <Loading/>
                        ) : (
                            <ScreenBar/>
                        )}
                    </div>
                </div>
            </ScreenDesignerContextNew.Provider>
        ) : (
            <div className={classes.container}>
                <Loading/>
            </div>
        )
    )
};

export default ScreenDesigner;